import { Link } from 'react-router-dom';
import { isAuthenticated } from '../../services/api';
import '../Unauthorized/unauthorized.css';

function ApiUnavailable() {
    const backPath = isAuthenticated() ? '/' : '/login';
    const backLabel = isAuthenticated() ? 'Tentar novamente' : 'Ir para login';

    return (
        <div className='unauthorized-page'>
            <div className='unauthorized-card container-white'>
                <h1>Estamos com instabilidade de comunicação</h1><br />

                <p>
                    Não conseguimos comunicar com o servidor neste momento.
                    Isso pode acontecer por indisponibilidade temporária ou falha de rede.
                    Aguarde alguns instantes e tente novamente.
                </p>

                <Link to={backPath} className='unauthorized-link'>
                    {backLabel}
                </Link>
            </div>
        </div>
    );
}

export default ApiUnavailable;
